var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultContractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.575 19.4C10.175 19.8 9.7 20 9.15 20C8.6 20 8.125 19.8 7.725 19.4L0.575 12.25C0.191667 11.8667 0 11.3958 0 10.8375C0 10.2792 0.191667 9.80833 0.575 9.425L9.375 0.6C9.55833 0.416667 9.775 0.270833 10.025 0.1625C10.275 0.0541667 10.5417 0 10.825 0H17.975C18.525 0 18.9958 0.195833 19.3875 0.5875C19.7792 0.979167 19.975 1.45 19.975 2V9.15C19.975 9.43333 19.9208 9.7 19.8125 9.95C19.7042 10.2 19.5583 10.4167 19.375 10.6L10.575 19.4ZM15.475 6C15.8917 6 16.2458 5.85417 16.5375 5.5625C16.8292 5.27083 16.975 4.91667 16.975 4.5C16.975 4.08333 16.8292 3.72917 16.5375 3.4375C16.2458 3.14583 15.8917 3 15.475 3C15.0583 3 14.7042 3.14583 14.4125 3.4375C14.1208 3.72917 13.975 4.08333 13.975 4.5C13.975 4.91667 14.1208 5.27083 14.4125 5.5625C14.7042 5.85417 15.0583 6 15.475 6Z",
    fill: "#265183"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultContractIcon);
export default __webpack_public_path__ + "static/media/default-contract-icon.a6d2cdb34cd77780c18068c06280248b.svg";
export { ForwardRef as ReactComponent };